var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"steps-container"},[_c('div',{staticClass:"steps"},_vm._l((_vm.steps),function(step){return _c('div',{staticClass:"step",class:{ 'active': step.active == true }},[_c('div',{staticClass:"icon"}),_c('span',{domProps:{"textContent":_vm._s(step.name)}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }